import React, { Component } from 'react';
import ConfiguratorSection from './../ConfiguratorSection';
import ConfiguratorImage from './../ConfiguratorImage';
import ConfiguratorOption from './../ConfiguratorOption';
import PdfForm from '../PdfForm';
import ShareFrom from '../ShareForm';
import Disclaimer from '../Disclaimer';
import TransomConfigurator from './../TransomConfigurator';
import { withTranslation, Trans } from 'react-i18next';
import { exterior_view01ImageOptions } from './views/exterior_view01'

class X56Summary extends Component {
    constructor(props) {
        super(props);

        this.state = {
            expanded: false
        };
    }

    render() {
		let imageOptions = exterior_view01ImageOptions;
        
        let image = (
            <TransomConfigurator colorMultiplier={0.75} name={this.props.configuration.transom.Name} port={this.props.configuration.transom.Port} transomSize={{ width: 2895, height: 780 }} transform={
                [
                    0.006642, -0.024054, 0, -0.000084,
                    0.000078, 0.067035, 0, 0.000019,
                    0, 0, 1, 0,
                    141, 378, 0, 1
                ]}>
                <ConfiguratorImage boat="X5_6" configuration={this.props.configuration.exterior} options={imageOptions} />
            </TransomConfigurator>
        );

        return (
            <ConfiguratorSection image={image}>

                <ConfiguratorOption style={{position:'relative'}}>

					<h1><Trans defaults='Summary' /></h1>
					<h2><Trans defaults='Congratulations!' /></h2>
					<p><Trans defaults='You have now configured the basics of an X5<sup>6</sup>. If you want a full configuration of your boat, please contact your local X-Yachts Dealer.' /></p>

                    <PdfForm boat="x56" country={this.props.country} countries={this.props.countries} configuration={this.props.configuration} code={this.props.code} />
                    
                    <ShareFrom configuration={this.props.configuration} boat="x56" code={this.props.code} />

                    <Disclaimer />
                </ConfiguratorOption>
            </ConfiguratorSection>
        );
    }
}

export default withTranslation()(X56Summary);


// WEBPACK FOOTER //
// ./src/X56/X56Summary.js